import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { SeDatetimePickerComponent, SeTimePickerComponent } from '@se/platform';
import { FocusSelectOnDirective } from '../../../directives/focus-select.directive';
import { DateCellEditorBaseComponent } from '../date-cell-editor-base/date-cell-editor-base.component';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'se-date-cell-editor-popup',
    templateUrl: './date-cell-editor-popup.component.html',
    styleUrls: ['./date-cell-editor-popup.component.scss'],
    imports: [
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatDatepickerModule,
        ReactiveFormsModule,
        SeDatetimePickerComponent,
        SeTimePickerComponent,
        FocusSelectOnDirective,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateCellEditorPopupComponent extends DateCellEditorBaseComponent {
    readonly width = input.required<string>();
}
